module.exports = __webpack_public_path__ + "fonts/PangMenZhengDao.e6033c0b.ttf";